import { z } from 'zod';
/** Who or what caused a change. Mirrors the provenance sources in the architecture doc. */
export const ActorType = z.enum(['user', 'system', 'agent', 'integration', 'auditor']);
/** Event types are `<aggregate>.<past-tense verb>`, e.g. `tenant.renamed`, `document.processed`. */
export const EventType = z.string().regex(/^[a-z][a-z_]*\.[a-z][a-z_]*$/, 'expected <aggregate>.<verb>');
export const DomainEventInput = z.object({
    type: EventType,
    aggregateType: z.string().min(1),
    aggregateId: z.string().min(1),
    payload: z.record(z.string(), z.unknown()).default({}),
    actorType: ActorType,
    actorId: z.string().nullable().default(null),
    traceId: z.string().nullable().default(null),
});
/** What a subscriber receives from the queue: the stored event, by id, with its tenant. */
export const EventJob = z.object({
    eventId: z.string(),
    tenantId: z.string().uuid().nullable(),
    type: EventType,
    aggregateType: z.string(),
    aggregateId: z.string(),
    payload: z.record(z.string(), z.unknown()),
    /**
     * The signed-in person the change was made for (also for agent events in their session). Workers act as
     * them, so row-level security applies to background work too. Null for system work.
     */
    userId: z.string().uuid().nullable().optional(),
});
//# sourceMappingURL=events.js.map